import { FC } from 'react';

import { IconProps } from './types';

export const UserIcon: FC<IconProps> = ({ size, height = 24, width = 24, color = '#06519E' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			d="M7 7c0 2.76 2.243 5 5 5s5-2.24 5-5-2.243-5-5-5-5 2.24-5 5zm2 0c0-1.65 1.346-3 3-3s3 1.35 3 3-1.346 3-3 3-3-1.35-3-3zm9 14a1.001 1.001 0 0 0 2 0v-2c0-2.76-2.243-5-5-5H9c-2.757 0-5 2.24-5 5v2c0 .55.448 1 1 1s1-.45 1-1v-2c0-1.65 1.346-3 3-3h6c1.654 0 3 1.35 3 3v2z"
			fillRule="evenodd"
		/>
	</svg>
);
